import { render, staticRenderFns } from "./apply-detail.vue?vue&type=template&id=b479cf72&scoped=true"
import script from "./apply-detail.vue?vue&type=script&lang=js"
export * from "./apply-detail.vue?vue&type=script&lang=js"
import style0 from "./apply-detail.vue?vue&type=style&index=0&id=b479cf72&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b479cf72",
  null
  
)

export default component.exports